import Vue from 'vue';
import App from './App.vue';
import type { QianKunProps } from './type/common';
import { enableLocalDevTokenbase, setPsHttp } from '@/config/http';
import { setLang } from '@/locales';
import { ProductsService, GetHost } from '@/components/ProductsServ';

let instance: Vue | null = null;
// const LAB_SERVICE = process.env.VUE_APP_LAB_SERVICE_URI;

// 独立运行时
if (!window.__POWERED_BY_QIANKUN__) {
    // @ts-ignore 默认用RND的CSS配置
    import('@patsnap-biz/design-tokens/scss/_variables-RD.css');
    enableLocalDevTokenbase()
        .then(() => bootstrap({})).then(() => mount({}));
}

export async function bootstrap(props: Partial<QianKunProps> = {}) {
    __webpack_public_path__ = `${process.env.VUE_APP_FULL_PUBLIC_PATH}`;
    if (props.psHttp) {
        setPsHttp(props.psHttp);
    }
}

export async function mount(props: Partial<QianKunProps>) {
    // Do init
    const topContainer = props?.container || document.body;

    setLang(props.lang || 'en');

    const productsService = new ProductsService();
    if (typeof props.customDataGetter === 'function') {
        productsService.dataGetter = props.customDataGetter;
    }

    if (typeof props.newProductsGetter === 'function') {
        productsService.newProductsGetter = props.newProductsGetter;
    }

    if (typeof props.newProductsUpdate === 'function') {
        productsService.newProductsUpdate = props.newProductsUpdate;
    }

    await productsService.sync();

    if (props.testProxy && props.psHttp) { // 自定义请求且testProxy不强制true时不验proxy
        try {
            if (!(window.location.host.indexOf('localhost') === 0 || window.location.host.indexOf('127.0.0.1') === 0)) {
                const LabHost = GetHost(document.getElementsByTagName('script')[0].baseURI);
                if (!(((LabHost.indexOf(['z', 'h', 'i', 'h', 'u', 'i', 'y', 'a', '.', 'c', 'o', 'm'].join('')) < 0 || LabHost.indexOf(['p', 'a', 't', 's', 'n', 'a', 'p', '.', 'c', 'o', 'm'].join('')) < 0 || LabHost.indexOf(['p', 'a', 't', 's', 'n', 'a', 'p', '.', 'e', 'u'].join('')) < 0)))) {
                    productsService.getAccoutTime();
                }
            }
        } catch (e) {
            console.log(e);
        }
    }

    instance = new Vue({
        provide: {
            topContainer: topContainer,
            mfeProps: props,
        },
        data() {
            return {
                productsService, // 响应式，不可以去掉
            };
        },
        render(h) {
            return h(App, {
                props: { service: productsService },
            });
        },

    });

    instance.$mount(topContainer.querySelector('#mfe-micro-headerwidgets-projects-app') as Element);
}

export async function update(props: Partial<QianKunProps>) {
    if (props.lang) {
        setLang(props.lang || 'en');
        // @ts-ignore
        if (instance && instance.productsService) {
            // @ts-ignore
            instance.productsService.refreshKey += '1';
        }
    }
}

export async function unmount() {
    if (instance) {
        instance.$destroy();
        instance.$el.innerHTML = '';
    }
    instance = null;
}
